import * as React from "react"
import { Platform, StyleProp, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { WebView } from 'react-native-webview';

const IFRAME = {
  border: 0
}

export interface WebcomponentProps {
  /**
   * An optional style override useful for padding & margin.
   */
  style?: StyleProp<ViewStyle>;
  url?: string;
  onLoad?: () => void;
}

/**
 * Describe your component here
 */
export const Webcomponent = observer(function Webcomponent(props: WebcomponentProps) {
  const { url, onLoad } = props

  return (
    Platform.OS === "web"
      ? <iframe src={url} height="100%" width="100%" style={IFRAME} />
      : <WebView /* startInLoadingState */ cacheEnabled onLoad={onLoad} source={{uri: url}} />
  )
})
